<template>
  <textarea
    class="import-area bg-input"
    @input="onImport($event)"
    v-bind:placeholder="$t('components.special_ship.import')"
  ></textarea>
</template>

<script>
import { SpecialShipImporter } from "@/services/special-ship-importer";

export default {
  name: "SpecialShipImportArea",
  methods: {
    onImport(event) {
      let data = event.target.value;
      if (data == null || data.length === 0) {
        return;
      }
      event.target.value = "";
      let imported = SpecialShipImporter.import(data);
      this.$emit("import", imported);
      this.clearSelection();
    },
    clearSelection() {
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      } else if (document.selection) {
        document.selection.empty();
      }
    }
  }
};
</script>

<style scoped>
.import-area {
  width: 100%;
  height: 4em;
  color: var(--color-text-reg);
  resize: none;
}
</style>
